import { useState, useEffect } from "react";
import IAPI from "../../../models/IAPI";
import { IIntegrationAccessCollection } from "../../../models/IIntegrationAccessCollection";
import Services from "../../../services/Services";
import snackbarService from "../../../services/ui-messaging/SnackbarService";
import { CustomAPIID } from "../functions/sharedFunctions";

export function useIntegrationAccess(token: string, id: number) {
  const [integrationAccess, setIntegrationAccess] = useState<IIntegrationAccessCollection>();
  const [showCustomAPIFields, setShowCustomAPIFields] = useState<boolean>(false);

  const getIntegrationAccess = async (): Promise<void> => {
    const svcs = new Services();
    const integrationRepo = await svcs.IntegrationRepository();
    if (id && id > 0) {
      const integration = await integrationRepo.getById(token, id);

      if (integration && integration.System.ID === CustomAPIID) {
        let access: IIntegrationAccessCollection = await integrationRepo.getIntegrationFields(token, id);
        if (access.ErrorLoadingProposedAccess) {
          snackbarService.error(
            "There was an error loading proposed field changes. Please upload a valid SDK file or submit a service call if you cannot resolve the issue.",
          );
        }
        let data = await integrationRepo.getIntegrationFields(token, id);
        setIntegrationAccess(data);
      }
    }
  };

  useEffect(() => {
    getIntegrationAccess();
  }, []);

  return { integrationAccess, getIntegrationAccess, showCustomAPIFields, setShowCustomAPIFields };
}

export function useSelectableApis(token: string, systemName: string): IAPI[] {
  const [selectableAPIs, setSelectableAPIs] = useState<IAPI[]>([]);

  useEffect(() => {
    const getSelectableAPIs = async (): Promise<void> => {
      let integrationRepo = await new Services().IntegrationRepository();
      let resp: IAPI[] = [];

      if (token) {
        resp = await integrationRepo.getAPIs(token, systemName);
        let newResp = resp.filter(api => api.ShowToVendors);
      }
      setSelectableAPIs(resp);
    };

    getSelectableAPIs();
  }, [systemName]);

  return selectableAPIs;
}
